import React from "react";
import { motion } from "framer-motion";
import "./about.css";
import bele from "../assets/images/bele.png"
import vision from "../assets/images/mission.png"
import mission from "../assets/images/vision.png"
import values from "../assets/images/values.png"
import aboutimg from "../assets/images/aboutimg1.png"
import HeroFooter from "../components/footer";
import founder from "../assets/images/founder1.png"

const fadeLoopAnimation = {
  animate: {
    opacity: [0, 1, 0],
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: "easeInOut"
    }
  }
};

// Animation for cards (fade and slide upward)
const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 }
};

// Animation for sliding down the heading
const slideDown = {
  initial: { opacity: 0, y: -50 },
  animate: { opacity: 1, y: 0, transition: { duration: 1 } },
};
const slideUp = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  const fadeAnimation = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 1 } },
  };
  
  // Animation for the image appearing with a slight zoom
  const imageAnimation = {
    initial: { scale: 0.8, opacity: 0 },
    animate: { scale: 1, opacity: 1, transition: { duration: 1.2 } },
  };
  

  const expertiseItems = [
    "Foreign Collaborations",
    "Joint Ventures and Strategic Partnerships",
    "Corporate Law",
    "Information Technology",
    "Business Ventures",
    "MSME",
    "Mediation and Dispute Resolution",
    "Start-up India Initiatives",
    "Property and Real Estate",
 
  ];
  
  // Animation for the section heading
  const headingAnimation = {
    initial: { opacity: 0, y: -20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 0.8 },
  };
  
  // Animation for the expertise list items
  const listItemAnimation = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0 },
  };
  

  const socialLinks = [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/sujata-patekar",
      icon: "fab fa-linkedin-in",
    },
    {
      name: "WhatsApp",
      url: "https://wa.me/918007913007",
      icon: "fab fa-whatsapp",
    },
    {
      name: "Email",
      url: "mailto:sujata@induratnalaw.com",
      icon: "fas fa-envelope",
    },
  ];


function About() {
  return (
    <div>
      
      
      {/* Animated "About Us" Heading */}
      
      
      <div className="intro-container">

      <motion.h1
        className="about-heading"
        initial="initial"
        animate="animate"
        variants={slideDown}
      >
        InduRatna Law Associates
      </motion.h1>
        <div className="intro-top">
          {/* Left Side: Picture with fade in-out effect */}
          <div
            className="intro-image"
            
          >
            <img src={aboutimg} alt="Induratna Laws" />
          </div>
       
          {/* Right Side: Introduction Text */}
          <motion.div
            className="intro-text"
            initial="initial"
            animate="animate"
            variants={fadeAnimation}
          >
            <h1></h1>
            <p style={{ color: 'white' }}>
            Induratna Laws stands as a beacon of legal excellence, where tradition meets innovation. Our dedicated team leverages extensive legal knowledge to offer comprehensive, client-focused services that uphold the highest standards of integrity and justice.<br/>Every case we handle is a step towards redefining the future of legal practice—ensuring that your journey towards justice is both empowering and transformative.
            </p>
          </motion.div>
        </div>

        {/* Bottom Section: Vision, Mission, Values, Beliefs */}
        <div className="intro-bottom">
          <motion.div
            className="card"
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            <img src={vision} alt="Vision Icon" />
            <h3>Vision</h3>
            <p>Revolutionizing legal practice with transparency and trust.</p>
          </motion.div>
          <motion.div
            className="card"
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            transition={{ duration: 0.8, delay: 0.7 }}
          >
            <img src={mission} alt="Mission Icon" />
            <h3>Mission</h3>
            <p>Empowering Business expanding Worldwide</p>
          </motion.div>
          <motion.div
            className="card"
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            <img src={values} alt="Values Icon" />
            <h3>Values</h3>
            <p>Integrity, excellence, and commitment to our clients.</p>
          </motion.div>
          {/* <motion.div
            className="card"
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            transition={{ duration: 0.8, delay: 1.1 }}
          >
            <img src="https://demo.satkarnewserver.com/demoindu/i0.wp.com/induratnalaw.com/wp-content/uploads/2023/10/Beliefs7b20.png?fit=50%2C50&ssl=1" alt="Beliefs Icon" />
            <h3>Beliefs</h3>
            <p>Our unwavering belief in justice fuels our every step.</p>
          </motion.div> */}
        </div>
        <motion.div
            className="card"
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            transition={{ duration: 0.8, delay: 1.1 }}
            style={{ marginTop: '25px' }}
          >
            <img src={bele} alt="Beliefs Icon" />
            <h3>Beliefs</h3>
            <p>“Lord, grant that I may be able in argument, accurate in analysis, diligent in study, candid with clients, and honest with adversaries. Sit with me at my desk, read with me in my library, and stand beside me in court, so that I may not, in winning a point, lose my soul.”<br/>
            – Sir Thomas More</p>
          </motion.div>
        <motion.div
          className="services-section"
           initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.2 }}
  transition={{ duration: 1 }}
        >
          <h2>Legal Advice Services</h2>
          <p>
            We provide Litigation Services, Legal Advice Services, Due Diligence and
            Legal Research, Legal Drafting Services and Legal Documentation Services,
            Land Acquisition Services and Real Estate Property Management Services,
            Residential and Commercial Construction Project Formation and Registration
            Services, Real Estate Property Transfer and Real Estate Conveyance, Real
            Estate Alternate Dispute Resolution Services, Family Property Succession
            Services, and Legal Compliances Services in PCMC (Pimpri Chinchwad),
            Pune, Maharashtra, India.
          </p>
        </motion.div>


        <div className="founder-section">
        {/* Founder Image */}
        <motion.div
          className="founder-image-container"
          initial={{ scale: 0, opacity: 0, y: 50 }}
  whileInView={{ scale: 1, opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.2 }}
  transition={{ duration: 0.8 }}
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.5 }}
        >
          <img
            src={founder}
            alt="Adv. Sujata Patekar"
            className="founder-image"
          />
        </motion.div>

        {/* Social Media Links */}
        <div className="social-links">
          {socialLinks.map((link, index) => (
            <motion.a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
            >
              <i className={link.icon}></i>
            </motion.a>
          ))}
        </div>

        {/* Founder Information */}
        <motion.div
          className="founder-details"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <h2>Advocate Sujata Patekar</h2>
          <p>
            Advocate Sujata Patekar is a distinguished legal professional and the 
            founder of InduRatna Law Associates, a corporate law firm based in 
            Pimpri-Chinchwad, Pune, Maharashtra, India. She holds a Bachelor of 
            Laws (LL.B.) degree from Symbiosis Law College (1993) and a Bachelor 
            of Commerce (B.Com) from the University of Pune. Additionally, she 
            completed a Post Graduate Diploma in Legal Process Outsourcing from 
            IGNOU, Delhi University.
          </p>
          <p>
            With vast experience in UK and US laws, Advocate Patekar has profound 
            expertise in Civil, Corporate, Commercial, International Laws, Property and Succession 
            Laws. Her specialization includes drafting and vetting a wide range of 
            contracts and agreements, as well as providing comprehensive legal 
            advice to Multinational Companies and Business.
          </p>
          <p>
            Known for her meticulous and client-centered approach, Advocate 
            Patekar has earned a reputation for transparency and in-depth legal 
            knowledge, making her a trusted advisor in the legal field.
          </p>
        </motion.div>
      </div>

      <motion.div
      className="expertise-section"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 1 }}
    >
      <motion.h2
        className="expertise-heading"
        initial={headingAnimation.initial}
        whileInView={headingAnimation.whileInView}
        viewport={headingAnimation.viewport}
        transition={headingAnimation.transition}
      >
        Our Expertise
      </motion.h2>

      <div className="expertise-list">
        {expertiseItems.map((item, index) => (
          <motion.div
            key={index}
            className="expertise-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            variants={listItemAnimation}
          >
            <span className="bullet-point">•</span> {item}
          </motion.div>
        ))}
      </div>
    </motion.div>

        {/* <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p>
      <p>hi</p> */}
      </div>
    
        <HeroFooter/>



    </div>
  );
}

export default About;
